import { RemoteDiagnosticsGetVddListByComChannelGeneric } from '../remote-diagnostics.model';
import { LogicalLinkVddList } from './mockedVddList.model';
export class LL_0059_VCMU_CAN54 implements LogicalLinkVddList {
  vddList(): RemoteDiagnosticsGetVddListByComChannelGeneric {
    return {
      service: 'DS_ReadDataByIdent',
      ecu: 'LL_0059_VCMU_CAN54',
      type: 'ListOfVDDsByBaseVariant',
      structure: [
        {
          semantic: '',
          path: 'PA_DataIdent',
          unit: '',
          translationid: '',
          dopname: '2 Byte Text Table VDD-Greenbook',
          name: 'PA_DataIdent',
          value: 'CustomerIndividualParameters',
          structure: [
            {
              TI_texttableentry: 'TI_BusIdentification',
              isRead: 'true',
              interval: '256',
              texttableentry: 'BusIdentification',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_StatusDtcList',
              isRead: 'true',
              interval: '257',
              texttableentry: 'StatusDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_StatusDtcHistory',
              isRead: 'true',
              interval: '258',
              texttableentry: 'StatusDtcHistory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InfoDtcList',
              isRead: 'true',
              interval: '259',
              texttableentry: 'InfoDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InfoDtcHistory',
              isRead: 'true',
              interval: '260',
              texttableentry: 'InfoDtcHistory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ServiceDtcList',
              isRead: 'true',
              interval: '261',
              texttableentry: 'ServiceDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ServiceDtcHistory',
              isRead: 'true',
              interval: '262',
              texttableentry: 'ServiceDtcHistory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_WarningDtcList',
              isRead: 'true',
              interval: '263',
              texttableentry: 'WarningDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_WarningDtcHistory',
              isRead: 'true',
              interval: '264',
              texttableentry: 'WarningDtcHistory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ErrorDtcList',
              isRead: 'true',
              interval: '265',
              texttableentry: 'ErrorDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ErrorDtcHistory',
              isRead: 'true',
              interval: '266',
              texttableentry: 'ErrorDtcHistory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PrimaryHeatExchangerLiquidTemperatureSensor',
              isRead: 'true',
              interval: '320',
              texttableentry: 'PrimaryHeatExchangerLiquidTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorInletTemperatureSensor',
              isRead: 'true',
              interval: '321',
              texttableentry: 'CompressorInletTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorInletPressureSensor',
              isRead: 'true',
              interval: '322',
              texttableentry: 'CompressorInletPressureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnhancedVapourInjectionTemperatureSensor',
              isRead: 'true',
              interval: '323',
              texttableentry: 'EnhancedVapourInjectionTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorOutletTemperatureSensor',
              isRead: 'true',
              interval: '324',
              texttableentry: 'CompressorOutletTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorOutletPressureSensor',
              isRead: 'true',
              interval: '325',
              texttableentry: 'CompressorOutletPressureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PrimaryHeatExchangerBaseHeater',
              isRead: 'true',
              interval: '354',
              texttableentry: 'PrimaryHeatExchangerBaseHeater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SecondaryHeatExchangerLiquidTemperatureSensor',
              isRead: 'true',
              interval: '355',
              texttableentry: 'SecondaryHeatExchangerLiquidTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ViessmannIdentificationNumber',
              isRead: 'true',
              interval: '377',
              texttableentry: 'ViessmannIdentificationNumber',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectronicExpansionValveOneTargetPositionPercent',
              isRead: 'true',
              interval: '388',
              texttableentry: 'ElectronicExpansionValveOneTargetPositionPercent',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectronicExpansionValveOneCurrentPositionPercent',
              isRead: 'true',
              interval: '389',
              texttableentry: 'ElectronicExpansionValveOneCurrentPositionPercent',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectronicExpansionValveTwoTargetPositionPercent',
              isRead: 'true',
              interval: '390',
              texttableentry: 'ElectronicExpansionValveTwoTargetPositionPercent',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectronicExpansionValveTwoCurrentPositionPercent',
              isRead: 'true',
              interval: '391',
              texttableentry: 'ElectronicExpansionValveTwoCurrentPositionPercent',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_Date',
              isRead: 'true',
              interval: '505',
              texttableentry: 'Date',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_Time',
              isRead: 'true',
              interval: '506',
              texttableentry: 'Time',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_UniversalTimeCoordinated',
              isRead: 'true',
              interval: '507',
              texttableentry: 'UniversalTimeCoordinated',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RemoteReset',
              isRead: 'true',
              interval: '573',
              texttableentry: 'RemoteReset',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RemoteResetCounter',
              isRead: 'true',
              interval: '574',
              texttableentry: 'RemoteResetCounter',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SetDeliveryStatus',
              isRead: 'false',
              interval: '575',
              texttableentry: 'SetDeliveryStatus',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SetDeliveryStatusDate',
              isRead: 'true',
              interval: '576',
              texttableentry: 'SetDeliveryStatusDate',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SoftwareVersion',
              isRead: 'true',
              interval: '580',
              texttableentry: 'SoftwareVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HardwareVersion',
              isRead: 'true',
              interval: '581',
              texttableentry: 'HardwareVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PowerOnCounter',
              isRead: 'true',
              interval: '582',
              texttableentry: 'PowerOnCounter',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectronicControlUnitOperationHours',
              isRead: 'true',
              interval: '590',
              texttableentry: 'ElectronicControlUnitOperationHours',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ServiceManagerIsRequired',
              isRead: 'true',
              interval: '901',
              texttableentry: 'ServiceManagerIsRequired',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MalfunctionIdentification',
              isRead: 'true',
              interval: '902',
              texttableentry: 'MalfunctionIdentification',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectronicTraceabilityNumber',
              isRead: 'true',
              interval: '928',
              texttableentry: 'ElectronicTraceabilityNumber',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrix',
              isRead: 'true',
              interval: '954',
              texttableentry: 'BusTopologyMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BootLoaderVersion',
              isRead: 'true',
              interval: '962',
              texttableentry: 'BootLoaderVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SparePartNumber',
              isRead: 'true',
              interval: '963',
              texttableentry: 'SparePartNumber',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ActiveDiagnosticSession',
              isRead: 'true',
              interval: '964',
              texttableentry: 'ActiveDiagnosticSession',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FreezeFrame',
              isRead: 'true',
              interval: '1081',
              texttableentry: 'FreezeFrame',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ParameterIdentificationVersion',
              isRead: 'true',
              interval: '1131',
              texttableentry: 'ParameterIdentificationVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ViessmannIdentificationNumberListInternal',
              isRead: 'true',
              interval: '1132',
              texttableentry: 'ViessmannIdentificationNumberListInternal',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerIndividualParameters',
              isRead: 'true',
              interval: '1141',
              texttableentry: 'CustomerIndividualParameters',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ResetDtcHistory',
              isRead: 'true',
              interval: '1166',
              texttableentry: 'ResetDtcHistory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AcknowledgeInfoAlarmMessage',
              isRead: 'true',
              interval: '1175',
              texttableentry: 'AcknowledgeInfoAlarmMessage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AcknowledgeWarningAlarmMessage',
              isRead: 'true',
              interval: '1176',
              texttableentry: 'AcknowledgeWarningAlarmMessage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AcknowledgeServiceAlarmMessage',
              isRead: 'true',
              interval: '1177',
              texttableentry: 'AcknowledgeServiceAlarmMessage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AcknowledgeErrorAlarmMessage',
              isRead: 'true',
              interval: '1178',
              texttableentry: 'AcknowledgeErrorAlarmMessage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ParameterIdentificationNumber',
              isRead: 'true',
              interval: '1213',
              texttableentry: 'ParameterIdentificationNumber',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ActorSensorTest',
              isRead: 'true',
              interval: '1239',
              texttableentry: 'ActorSensorTest',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HeatEnginePerformanceParameter',
              isRead: 'true',
              interval: '1283',
              texttableentry: 'HeatEnginePerformanceParameter',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MalfunctionHeatingUnitBlocked',
              isRead: 'true',
              interval: '1339',
              texttableentry: 'MalfunctionHeatingUnitBlocked',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SafetyRelevantRemoteUnlock',
              isRead: 'true',
              interval: '1467',
              texttableentry: 'SafetyRelevantRemoteUnlock',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SensorActuatorTestGroupHeatEngine',
              isRead: 'true',
              interval: '1469',
              texttableentry: 'SensorActuatorTestGroupHeatEngine',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HeatEnginePerformanceStatistics',
              isRead: 'true',
              interval: '1493',
              texttableentry: 'HeatEnginePerformanceStatistics',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_OemProductVersion',
              isRead: 'true',
              interval: '1494',
              texttableentry: 'OemProductVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectronicControlUnitOdxVersion',
              isRead: 'true',
              interval: '1553',
              texttableentry: 'ElectronicControlUnitOdxVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ParameterIdentificationVersionFactory',
              isRead: 'true',
              interval: '1595',
              texttableentry: 'ParameterIdentificationVersionFactory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ReceiverTemperatureSensor',
              isRead: 'true',
              interval: '1768',
              texttableentry: 'ReceiverTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PrimaryInletTemperatureSensor',
              isRead: 'true',
              interval: '1769',
              texttableentry: 'PrimaryInletTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SecondaryOutletTemperatureSensor',
              isRead: 'true',
              interval: '1770',
              texttableentry: 'SecondaryOutletTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EngineRoomTemperatureSensor',
              isRead: 'true',
              interval: '1771',
              texttableentry: 'EngineRoomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorOilTemperatureSensor',
              isRead: 'true',
              interval: '1772',
              texttableentry: 'CompressorOilTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RefrigerantCircuitFourWayValve',
              isRead: 'true',
              interval: '1773',
              texttableentry: 'RefrigerantCircuitFourWayValve',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorCrankCaseHeater',
              isRead: 'true',
              interval: '1774',
              texttableentry: 'CompressorCrankCaseHeater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PrimaryCircuitFanOne',
              isRead: 'true',
              interval: '1775',
              texttableentry: 'PrimaryCircuitFanOne',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PrimaryCircuitFanTwo',
              isRead: 'true',
              interval: '1776',
              texttableentry: 'PrimaryCircuitFanTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HeatPumpCompressorCurrentOperatingPoint',
              isRead: 'true',
              interval: '1846',
              texttableentry: 'HeatPumpCompressorCurrentOperatingPoint',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MinimumSecondaryReturnTemperatureRefrigerantCircuit',
              isRead: 'true',
              interval: '2255',
              texttableentry: 'MinimumSecondaryReturnTemperatureRefrigerantCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DesiredThermalEnergyDefrost',
              isRead: 'true',
              interval: '2256',
              texttableentry: 'DesiredThermalEnergyDefrost',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RefrigerationCircuitStatus',
              isRead: 'true',
              interval: '2259',
              texttableentry: 'RefrigerationCircuitStatus',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_NominalThermalCapacityHeating',
              isRead: 'true',
              interval: '2342',
              texttableentry: 'NominalThermalCapacityHeating',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_NominalThermalCapacityCooling',
              isRead: 'true',
              interval: '2343',
              texttableentry: 'NominalThermalCapacityCooling',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorSetpointPercent',
              isRead: 'true',
              interval: '2345',
              texttableentry: 'CompressorSetpointPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CompressorSpeedPercent',
              isRead: 'true',
              interval: '2346',
              texttableentry: 'CompressorSpeedPercent',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HeatPumpCompressor',
              isRead: 'true',
              interval: '2351',
              texttableentry: 'HeatPumpCompressor',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HeatPumpCompressorStatistical',
              isRead: 'true',
              interval: '2369',
              texttableentry: 'HeatPumpCompressorStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_OutdoorUnitDefrostingFunction',
              isRead: 'true',
              interval: '2381',
              texttableentry: 'OutdoorUnitDefrostingFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectronicExpansionValveRegulationParameter',
              isRead: 'true',
              interval: '2386',
              texttableentry: 'ElectronicExpansionValveRegulationParameter',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CurrentElectricalPowerConsumptionRefrigerantCircuit',
              isRead: 'true',
              interval: '2486',
              texttableentry: 'CurrentElectricalPowerConsumptionRefrigerantCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CurrentThermalCapacityRefrigerantCircuit',
              isRead: 'true',
              interval: '2494',
              texttableentry: 'CurrentThermalCapacityRefrigerantCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RefrigerantType',
              isRead: 'true',
              interval: '2568',
              texttableentry: 'RefrigerantType',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorSpeedRps',
              isRead: 'true',
              interval: '2569',
              texttableentry: 'CompressorSpeedRps',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorOnTimer',
              isRead: 'true',
              interval: '2573',
              texttableentry: 'CompressorOnTimer',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RefrigerationCircuitDesiredOperatingMode',
              isRead: 'true',
              interval: '2578',
              texttableentry: 'RefrigerationCircuitDesiredOperatingMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CompressorMinMaxAllowedPrimaryTemperatureHeating',
              isRead: 'true',
              interval: '2579',
              texttableentry: 'CompressorMinMaxAllowedPrimaryTemperatureHeating',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorSetpointRps',
              isRead: 'true',
              interval: '2580',
              texttableentry: 'CompressorSetpointRps',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorOffTimer',
              isRead: 'true',
              interval: '2582',
              texttableentry: 'CompressorOffTimer',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PrimarySourceCommonSettingsHeating',
              isRead: 'true',
              interval: '2612',
              texttableentry: 'PrimarySourceCommonSettingsHeating',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PrimarySourceCommonSettingsCooling',
              isRead: 'true',
              interval: '2613',
              texttableentry: 'PrimarySourceCommonSettingsCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DesiredThermalCapacity',
              isRead: 'true',
              interval: '2629',
              texttableentry: 'DesiredThermalCapacity',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorMinMaxSpeedHeating',
              isRead: 'true',
              interval: '2630',
              texttableentry: 'CompressorMinMaxSpeedHeating',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorMinMaxSpeedCooling',
              isRead: 'true',
              interval: '2631',
              texttableentry: 'CompressorMinMaxSpeedCooling',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorMinMaxSpeedDefrost',
              isRead: 'true',
              interval: '2632',
              texttableentry: 'CompressorMinMaxSpeedDefrost',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MaxSpeedNoiseReductionMode',
              isRead: 'true',
              interval: '2633',
              texttableentry: 'MaxSpeedNoiseReductionMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_NoiseReductionMode',
              isRead: 'true',
              interval: '2634',
              texttableentry: 'NoiseReductionMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SecondaryHeatExchangerVaporPressureSensor',
              isRead: 'true',
              interval: '2784',
              texttableentry: 'SecondaryHeatExchangerVaporPressureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RefrigerationCircuitOperationMode',
              isRead: 'true',
              interval: '2806',
              texttableentry: 'RefrigerationCircuitOperationMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SecondaryHeatExchangerMaximumOutletTemperature',
              isRead: 'true',
              interval: '2845',
              texttableentry: 'SecondaryHeatExchangerMaximumOutletTemperature',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RefrigerantCycleAvailability',
              isRead: 'true',
              interval: '2894',
              texttableentry: 'RefrigerantCycleAvailability',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PumpdownControl',
              isRead: 'true',
              interval: '2941',
              texttableentry: 'PumpdownControl',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectronicControlUnitSafeStateStatus',
              isRead: 'true',
              interval: '2969',
              texttableentry: 'ElectronicControlUnitSafeStateStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_OutdoorMiddleCoilTemperatureSensor',
              isRead: 'true',
              interval: '3014',
              texttableentry: 'OutdoorMiddleCoilTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HeatSinkTemperatureSensor',
              isRead: 'true',
              interval: '3015',
              texttableentry: 'HeatSinkTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorOutletTargetTemperature',
              isRead: 'true',
              interval: '3019',
              texttableentry: 'CompressorOutletTargetTemperature',
              isWrite: 'false',
            },
          ],
        },
      ],
    };
  }
}
